// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Group, Skeleton, Text } from '@mantine/core';
import { FC, useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ContractTemplateContext } from '../../Service/Context/ContractTemplateContext';
import { ContractContext } from '../../Service/Context/ContractContextV2';
import DocumentSelectorModal from '../../Templates/Documents/DocumentSelectorModal';

interface Props {
  id?: number;
  isAbove: boolean;
  withoutGap?: boolean;
}

export const ContractBlockButtons: FC<Props> = ({ id, isAbove, withoutGap = false }) => {
  const { id: eventId } = useParams();
  const { contract, addBlock, handleChange } = useContext(ContractContext);
  const [loading, setLoading] = useState(false);
  const { id: contractId, positions } = contract ?? {};

  // eslint-disable-next-line no-underscore-dangle
  const _addBlock = async () => {
    setLoading(true);
    await addBlock(isAbove, id);
    setLoading(false);
  };

  return (
    <>
      {loading && <Skeleton my="md" height={200} />}
      {!loading && (
        <Group mt={5} mb="sm" ml={withoutGap ? 0 : 30}>
          {!positions && id && (
            <DocumentSelectorModal
              eventId={eventId}
              handleChange={handleChange}
              contractId={contractId}
              contractTemplateName={undefined}
              textBlockId={id}
            />
          )}
          <Text color="blue" variant="link" sx={{ cursor: 'pointer' }} onClick={_addBlock}>
            + Textblock hinzufügen
          </Text>
        </Group>
      )}
    </>
  );
};

export const ContractTemplateBlockButtons: FC<Props> = ({ id, isAbove, withoutGap = false }) => {
  const { template, addBlock, insertPositions } = useContext(ContractTemplateContext);
  const [loading, setLoading] = useState(false);
  const { positions } = template ?? {};

  // eslint-disable-next-line no-underscore-dangle
  const _addBlock = async () => {
    setLoading(true);
    await addBlock(isAbove, id);
    setLoading(false);
  };

  return (
    <>
      {loading && <Skeleton my="md" height={200} />}
      {!loading && (
        <Group mt={5} mb="sm" ml={withoutGap ? 0 : 30}>
          {!positions && id && (
            <Text color="blue" variant="link" sx={{ cursor: 'pointer' }} onClick={() => insertPositions(id)}>
              + Positionen hier einfügen
            </Text>
          )}
          <Text color="blue" variant="link" sx={{ cursor: 'pointer' }} onClick={_addBlock}>
            + Textblock hinzufügen
          </Text>
        </Group>
      )}
    </>
  );
};
